import { Component, Inject } from '@angular/core';

import { Router } from '@angular/router';

import { EnvironmentConfig } from '../../../config/environment.config';

@Component({
  selector: 'mom-header-with-logo',
  templateUrl: './header-with-logo.component.html',
  styleUrls: ['./header-with-logo.component.scss']
})
export class HeaderWithLogoComponent {
  logo = this.environment.logoPath;
  logoAltName = `${this.environment.appName} Logo`;

  constructor(@Inject('environment') private environment: EnvironmentConfig, private router: Router) {}

  goHome(): void {
    this.router.navigate(['home']);
  }
}
